import { render } from "./PostItem.vue?vue&type=template&id=571e43d0&scoped=true"
import script from "./PostItem.vue?vue&type=script&lang=ts"
export * from "./PostItem.vue?vue&type=script&lang=ts"

import "./PostItem.vue?vue&type=style&index=0&id=571e43d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-571e43d0"

export default script